<template>

  <div class="w-100 p-2 mt-2">
    <page-header :name="'Platform Wallet history'">
      <b-icon-wallet class="mr-2"></b-icon-wallet> {{ $t('page.title.platform_wallet_history') }}
      <template v-slot:right>
        <b-button @click="addCoins('FUN_COINS')" size="sm" class="mr-1" variant="fs">+ {{$t('platform.wallet.add.fs.grid.btn')}}</b-button>
        <b-button @click="addCoins('QUIZ_COINS')" size="sm" variant="qc">+ {{$t('platform.wallet.add.qc.grid.btn')}}</b-button>
      </template>
    </page-header>
    <platform-wallets-history ref="table"></platform-wallets-history>
  </div>
</template>

<script>

import PlatformWalletsHistory from "../components/PlatformWalletsHistory";
import PageHeader from "../../../components/page/PageHeader";
import Vue from "vue";
import AddCoinsModal from "../components/AddCoinsModal";
export default {
  props: [],
  components: {PageHeader, PlatformWalletsHistory},
  data() {
    return {};
  },
  mounted() {

  },
  computed: {
  },
  methods: {
    addCoins(type) {
      const
          ModalConstructor = Vue.extend(AddCoinsModal),
          modal = new ModalConstructor({parent: this});
      modal.form.currency = type;

      if (type === 'FUN_COINS') {
        modal.title = 'platform.wallet.add.fs.title';
      } else {
        modal.title = 'platform.wallet.add.qc.title';
      }


      modal.$mount();
    }
  },
  watch: {}
}
</script>
